import { Box, colors, Container, Unstable_Grid2 as Grid, Typography } from '@mui/material';
import React from 'react';
import { LoginDetails } from './LoginDetails';

export const Login: React.FC<any> = () => {
    return (
        <Container
            maxWidth='sm'
            sx={{
                background: colors.common.white,
            }}
        >
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    py: 8,
                }}
            >
                <Typography sx={{ mb: 3 }} variant="h4">Login</Typography>
                <Grid xs={12} md={6} lg={4}>
                    <LoginDetails />
                </Grid>
            </Box>
        </Container>
    )
}
